import config from 'utils/config';

export const isInfantsOnLapEnabled = () => config('ENABLE_INFANTS_ON_LAP', { canOverride: true }) === 'true';

export const isCloneExternalTicketsEnabled = () => config('ENABLE_CLONE_EXTERNAL_TICKETS', { canOverride: true }) === 'true';

export const isSNCBUnconfirmedTimetableBookingExchangeEnabled = () =>
  config('ENABLE_SNCB_UNCONFIRMED_TIMETABLE_BOOKING_EXCHANGE', { canOverride: true }) === 'true';

export const isSNCBUnconfirmedTimetableManageBookingEnabled = () =>
  config('ENABLE_SNCB_UNCONFIRMED_TIMETABLE_MANAGE_BOOKING', { canOverride: true }) === 'true';

export const isDisruptedTrainsInSearchResultsEnabled = () =>
  config('ENABLE_DISRUPTED_TRAINS_IN_SEARCH_RESULTS', { canOverride: true }) === 'true';
